import http from './api'

export interface MissingMatchInsight {
  matchId: string
  teamA: string
  teamB: string
  kickoff: string
  league: string
}

export interface MissingPlayerInsight {
  userId: string
  name: string
  email: string
  missingMatches: MissingMatchInsight[]
}

export interface MissingRoomInsight {
  roomId: string
  roomName: string
  leagues: string[]
  players: MissingPlayerInsight[]
}

export interface MissingPredictionsReport {
  generatedAt: string
  windowHours: number
  windowEnd: string
  summary: {
    roomsWithMissing: number
    playersWithMissing: number
    missingPredictions: number
  }
  rooms: MissingRoomInsight[]
}

export async function getMissingRoomPredictions(hours = 48): Promise<MissingPredictionsReport> {
  const { data } = await http.get<MissingPredictionsReport>('/admin/missing-room-predictions', {
    params: { hours },
  })
  return data
}
